<template>
    <AppLayout>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
            <div class="widget widget-six">
                <div class="widget-heading d-block">
                    <ul style="list-style-type: none; padding: 0" v-for="error in $page.props.flash.errors">
                        <li class="alert alert-danger">{{ error }}</li>
                    </ul>
                </div>

                <div class="widget-content mb-0 pb-0">
                    <div class="switches-bar d-flex justify-content-end align-items-start w-100 gap-4">

                        <div class="form-check form-switch form-switch-success d-flex align-items-center switch-item">
                            <input class="form-check-input" type="checkbox" role="switch" id="showDwOnly"
                                style="height:1.4em; width:2.5em;" :checked="showDWOnly" @change="toggleDWOnly">
                            <label class="form-check-label ms-2 switch-label" for="showDwOnly">
                                Pokaż tylko DW
                            </label>
                        </div>

                        <div class="form-check form-switch form-switch-success d-flex align-items-center switch-item">
                            <input class="form-check-input" type="checkbox" role="switch" id="showPzOnly"
                                style="height:1.4em; width:2.5em;" :checked="showPZOnly" @change="togglePZOnly">
                            <label class="form-check-label ms-2 switch-label" for="showPzOnly">
                                Pokaż tylko PZ
                            </label>
                        </div>

                    </div>
                    <div>
                        <ejs-grid ref="warehouseMovementsGrid" id="warehouseMovementsGridId"
                            :height="selectedDocument?.id ? '40vh' : gridHeight"
                            :dataSource="warehouseMovementsDataManager" :allowTextWrap='false' :rowHeight="32"
                            :allowExcelExport='true' :allowPaging="true" :allowSorting='true' :allowFiltering='true'
                            :allowReordering='true' :allowResizing='true' :showColumnChooser='true'
                            :allowSelection='true' :enablePersistence='true' :pageSettings="pageSettings"
                            :editSettings="editSettings" :filterSettings="filterOptions" :toolbar="toolbar"
                            :actionComplete="actionComplete" :rowSelected="onRowSelected"
                            :toolbarClick="clickToolbarHandler" @cellEdit='cellEdit' :rowDataBound="rowDataBound">
                            <e-columns>
                                <e-column field="id" headerText="ID" :allowEditing="false" isPrimaryKey="true"
                                    :visible="false"></e-column>
                                <e-column field="document_number" headerText="Numer Dokumentu" :filter="filterDefault"
                                    :allowEditing="false" width="180" :template="'documentNumberTemplate'" />
                                <e-column field="order_number" width="180" headerText="Numer zamówienia"
                                    :filter="filterDefault" :allowEditing="false" />
                                <e-column field="previous_article_warehouse.short_name" headerText="Poprzedni magazyn"
                                    :filter="filterWarehouses" :allowEditing="false"
                                    :template="'warehousePrevTemplate'" />
                                <e-column field="article_warehouse.short_name" headerText="Magazyn"
                                    :filter="filterWarehouses" :allowEditing="false" :template="'warehouseTemplate'" />
                                <e-column field="comment" headerText="Komentarz" :allowFiltering="false"
                                    :template="'commentTemplate'" :allowSorting="false" />
                                <e-column field="closed" headerText="Status" :allowEditing="true"
                                    :allowFiltering="false" type="number" :editType="'dropdownedit'" :edit="closedEdit"
                                    :template="'closedTemplate'">
                                </e-column>
                                <e-column field="who_issuing" headerText="Wydał" :filter="filterDefault" />
                                <e-column field="who_receiving" headerText="Odebrał" :filter="filterDefault" />
                                <e-column field="additional_comment" headerText="Dodatkowy komentarz"
                                    :allowFiltering="false" :template="'additionalcommentTemplate'"
                                    :allowSorting="false" />

                                <e-column field="created_by_name" headerText="Utworzony przez"
                                    :filter="filterDefault" />
                                <e-column field="created_at" headerText="Data utworzenia" format="dd.MM.yyyy"
                                    :filter="filterDefault" />
                            </e-columns>

                            <template v-slot:warehousePrevTemplate="{ data }">
                                {{ data.previous_article_warehouse?.short_name ?? "" }}
                            </template>

                            <template v-slot:warehouseTemplate="{ data }">
                                {{ data.article_warehouse?.short_name ?? "" }}
                            </template>

                            <template v-slot:commentTemplate="{ data }">
                                {{ data.comment ?? "" }}
                            </template>
                            <template v-slot:additionalcommentTemplate="{ data }">
                                {{ data.additional_comment ?? "" }}
                            </template>
                            <template v-slot:documentNumberTemplate="{ data }">
                                <span class="text-primary cursor-pointer" @click="showDocument(data)"><i
                                        class="bi bi-search"></i> {{ data.document_number }}</span>
                            </template>

                            <template v-slot:closedTemplate="{ data }">
                                <span v-if="data.closed === 1">
                                    Zamknięty
                                </span>
                                <span v-else>Otwarty</span>
                            </template>

                        </ejs-grid>
                    </div>
                </div>

                <ViewMovementDetails v-if="showViewMovementDetails && selectedDocument"
                    :title="'Ruch magazynowy dla dokumentu ' + selectedDocument.document_number"
                    ref="viewMovementDetailsRef" @successMsg="successMsg" @errorMsg="errorMsg" :warehouses="warehouses"
                    :selectedDocument="selectedDocument" :producers="producers"
                    :table_settings="table_settings_selected" />

                <GeneratePdfModal ref="generatePdfModalRef" :selectedItem="selectedItem" />

                <PreviewMovementPdfModal v-if="showPreviewMovementPdfModal" ref="previewMovementPdfModalRef"
                    :isFilled="isFilled" :item="selectedItem" :movement="selectedMovement" :customers="customers" />

                <AddDocumentModal v-if="showAddDocumentModal" ref="addDocumentModalRef" @added="updateGrid()" />

            </div>
        </div>


    </AppLayout>
</template>

<script>
import AppLayout from "../../../Layouts/App.vue";
import { useForm, usePage } from "@inertiajs/vue3";
import { AutoComplete, MultiSelect } from '@syncfusion/ej2-vue-dropdowns';
import {
    ColumnChooser,
    ColumnDirective,
    ColumnsDirective,
    ContextMenu,
    Edit,
    ExcelExport,
    Filter,
    ForeignKey,
    GridComponent,
    Page,
    Reorder,
    Resize,
    Sort,
    Toolbar,
    Group,
} from '@syncfusion/ej2-vue-grids';
import { createElement } from "@syncfusion/ej2-base";
import { DataManager, Query, WebMethodAdaptor, Predicate } from '@syncfusion/ej2-data';
import { ComboBox, DropDownList } from "@syncfusion/ej2-dropdowns";
import moment from "moment";
import { ref } from "vue";

import { usePermission } from "@/composables/resources/js/composables/permissions.js";
import ViewMovementDetails from "./ViewMovementDetails.vue";
import GeneratePdfModal from "./GeneratePdfModal.vue";
import PreviewMovementPdfModal from "./PreviewMovementPdfModal.vue";
import AddDocumentModal from "./AddDocumentModal.vue";
import AddStockWarehouseModal from "../AddStockWarehouseModal.vue";

const { hasRole, hasPermission } = usePermission();


let dropInstanceFilterUnits, statusElem, statusObj;
export default {

    components: {
        AddStockWarehouseModal,
        AddDocumentModal,
        GeneratePdfModal,
        PreviewMovementPdfModal,
        ViewMovementDetails,
        hasPermission,
        AppLayout,
        MultiSelect,
        'ejs-grid': GridComponent,
        'e-columns': ColumnsDirective,
        'e-column': ColumnDirective
    },

    provide: {
        grid: [Page, Edit, Toolbar, ContextMenu, Sort, Filter, Reorder, Resize, ColumnChooser, ExcelExport, ForeignKey, Group]
    },

    props: {
        users: Object,
        warehouses: Object,
        producers: Object,
        customers: {
            type: Array,
            default: () => []
        },
		table_settings: {
			type: Object,
			now_restore_table: {
				type: Number,
				default: 1
			},
			default: null
		},
		table_settings_selected: {
			type: Object,
			now_restore_table_items: {
			type: Number,
			default: 1
			},
			default: null
		}
    },

    beforeMount() {
        this.getMovements();
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.calculateGridHeight)
    },
    data() {

        return {
            tableSettingsApplied: false,
            hasTableSettings: false,
            showAddDocumentModal: false,
            showViewMovementDetails: false,
            showPreviewMovementPdfModal: false,
            gridHeight: '56vh',
            hasPermission,
            warehouseMovementsDataManager: [],
            selectedDocument: null,
            selectedItem: null,
            selectedMovement: null,
            isFilled: true,
            showDWOnly: false,
            showPzOnly: false,
            pageSettings: { pageSize: 30, pageCount: 5, pageSizes: [10, 20, 30, 50, 100] },
            filterOptions: {
                type: "Menu",
                operator: 'contains',
            },
            filterDefault: { operator: 'contains', params: { minLength: 2 } },
            toolbar: this.getToolbar(),
            editSettings: this.getEditSettings(),
            filterWarehouses: {
                operator: 'contains',
                ui: {
                    create: (args) => {
                        let flValInput = createElement('input', { className: 'flm-input' });
                        args.target.appendChild(flValInput);
                        dropInstanceFilterUnits = new DropDownList({
                            dataSource: this.warehouses,
                            fields: { text: 'short_name', value: 'id' },
                            placeholder: 'Szukaj magazynu',
                            popupHeight: '200px',
                            allowFiltering: true
                        });
                        dropInstanceFilterUnits.appendTo(flValInput);
                    },
                    write: (args) => {
                        dropInstanceFilterUnits.text = args.filteredValue || '';
                    },
                    read: (args) => {
                        args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
                    }
                }
            },

            filterLocations: {
                operator: 'contains',
                ui: {
                    create: (args) => {
                        let flValInput = createElement('input', { className: 'flm-input' });
                        args.target.appendChild(flValInput);
                        dropInstanceFilterUnits = new DropDownList({
                            dataSource: this.locations,
                            fields: { text: 'short_name', value: 'id' },
                            placeholder: 'Szukaj magazynu',
                            popupHeight: '200px',
                            allowFiltering: true
                        });
                        dropInstanceFilterUnits.appendTo(flValInput);
                    },
                    write: (args) => {
                        dropInstanceFilterUnits.text = args.filteredValue || '';
                    },
                    read: (args) => {
                        args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
                    }
                }
            },

            closedEdit: {
                params: {
                    dataSource: [
                        { text: 'Zamknięty', value: 1 },
                        { text: 'Otwarty', value: 0 }
                    ],
                    query: new Query(),
                    fields: { text: 'text', value: 'value' }
                }
            },

            filterCreatedBy: {
                operator: 'contains',
                ui: {
                    create: (args) => {
                        let flValInput = createElement('input', { className: 'flm-input' });
                        args.target.appendChild(flValInput);
                        dropInstanceFilterUnits = new DropDownList({
                            dataSource: this.users,
                            fields: { text: 'name', value: 'id' },
                            placeholder: 'Szukaj kto stworzył',
                            popupHeight: '200px',
                            allowFiltering: true
                        });
                        dropInstanceFilterUnits.appendTo(flValInput);
                    },
                    write: (args) => {
                        dropInstanceFilterUnits.text = args.filteredValue || '';
                    },
                    read: (args) => {
                        args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
                    }
                }
            },


            orderItemWarehousesParams: {
                create: () => {
                    statusElem = document.createElement('input');
                    return statusElem;
                },
                read: () => {
                    return statusObj.text;
                },
                destroy: () => {
                    statusObj.destroy();
                },
                write: () => {
                    statusObj = new DropDownList({
                        dataSource: this.warehouses,
                        fields: { value: 'id', text: 'short_name' },
                        enabled: true,
                        placeholder: 'Wybierz magazyn',
                        floatLabelType: 'Never',
                        change: async (event) => {
                            statusObj.value = await this.onChangeWarehouse(event)
                        }
                    });
                    statusObj.appendTo(statusElem);
                }
            },
        }
    },
    watch: {
        table_settings: {
            immediate: true,
            deep: true,
            handler(value) {
                this.hasTableSettings = !!(value?.settings);

                this.$nextTick(() => {
                    const grid = this.$refs.warehouseMovementsGrid?.ej2Instances;

                    if (grid) {
                        grid.toolbar = this.getToolbar();
                    }
                });
            }
        }
    },
    mounted() {

        this.calculateGridHeight();
        window.addEventListener('resize', this.calculateGridHeight);

        const grid = this.$refs.warehouseMovementsGrid.ej2Instances;
        const searchInput = document.getElementById('customSearchInput');
        if (searchInput) {
            searchInput.addEventListener('input', (e) => {
                const keys = e.target.value.split(',').map(k => k.trim()).filter(k => k);
                if (!keys.length) {
                    grid.query = new Query();
                    grid.refresh();
                    return;
                }
                let predicate;
                grid.getColumns().forEach((col) => {
                    keys.forEach((key, index) => {
                        const pred = new Predicate(col.field, 'contains', key, true);
                        predicate = index === 0 && !predicate ? pred : predicate.or(pred);
                    });
                });
                grid.query = new Query().where(predicate);
                grid.refresh();
            });
        }
    },

    methods: {
		  restoreTableIfNeeded() {
    if (this.now_restore_table !== 0) {
      return;
    }

    let grid = this.$refs.warehouseMovementsGrid;

    if (!grid || !grid.$el || !grid.ej2Instances) {
      return;
    }

    let gridName = 'grid' + grid.$el.id;

    grid.ej2Instances.enablePersistence = false;

    window.localStorage.setItem(gridName, "");

    grid.ej2Instances.destroy();

    (function stripIdsFromUrl() {
      try {
        const url = new URL(window.location.href);

        url.searchParams.delete('ids');
        url.searchParams.delete('ids[]');

        history.replaceState(
          history.state,
          '',
          url.toString()
        );
      } catch (e) {
        const href = window.location.href;

        const cleaned = href
          .replace(/([?&])ids(\[\])?=[^&#]*&?/g, '$1')
          .replace(/[?&]$/, '');

        history.replaceState(
          history.state,
          '',
          cleaned
        );
      }
    })();
	this.applyTableSettings();
    location.reload();
  },
        applyTableSettings() {
            const grid = this.$refs.warehouseMovementsGrid?.ej2Instances;

            if (!grid || !this.table_settings?.settings) {
                return;
            }

            let settings;

            try {
                settings = JSON.parse(this.table_settings.settings);
            } catch (error) {
                console.error('Błąd odczytu ustawień tabeli:', error);
                return;
            }

            if (!Array.isArray(settings)) {
                return;
            }

            settings.forEach(setting => {
                if (!setting.field) {
                    return;
                }

                const column = grid.columns.find(
                    col => col.field === setting.field
                );

                if (!column) {
                    return;
                }

                if (setting.width !== undefined) {
                    column.width = setting.width;
                }

                column.visible = setting.visible !== false;
            });

            grid.refreshColumns();

            const savedFields = settings
                .filter(setting => setting.field)
                .sort((a, b) => a.index - b.index)
                .map(setting => setting.field);
            const currentFields = grid.columns
                .filter(column => column.field)
                .map(column => column.field);

            savedFields.forEach((field, targetIndex) => {
                const currentIndex = currentFields.indexOf(field);

                if (currentIndex === -1 || currentIndex === targetIndex) {
                    return;
                }

                const targetField = currentFields[targetIndex];

                if (!targetField) {
                    return;
                }

                grid.reorderColumns(
                    field,
                    targetField
                );

                currentFields.splice(currentIndex, 1);
                currentFields.splice(targetIndex, 0, field);
            });

            grid.refreshColumns();
        },

        calculateGridHeight() {
            const topOffset =
                document.getElementById('orderListGridId')
                    ?.getBoundingClientRect().top || 200
            this.gridHeight = `${window.innerHeight - topOffset - 200}px`
        },

        toggleDWOnly() {
            if (this.showDWOnly) {
                this.showDWOnly = false;
            } else {
                this.showDWOnly = true;
                this.showPZOnly = false;
            }

            this.selectedDocument = null;

            const grid = this.$refs.warehouseMovementsGrid?.ej2Instances;
            grid?.clearSelection();

            this.getMovements();
        },

        togglePZOnly() {
            if (this.showPZOnly) {
                this.showPZOnly = false;
            } else {
                this.showPZOnly = true;
                this.showDWOnly = false;
            }

            this.selectedDocument = null;

            const grid = this.$refs.warehouseMovementsGrid?.ej2Instances;
            grid?.clearSelection();

            this.getMovements();
            this.$nextTick(() => {
                const grid = this.$refs.warehouseMovementsGrid?.ej2Instances;
                if (!grid) return;

                grid.refresh();          // pełny rerender
                grid.refreshColumns();   // przeliczenie szerokości
                grid.recalcLayout?.();   // jeśli dostępne w Twojej wersji
            });
        },

        getEditSettings() {
            return {
                allowEditing: hasPermission('canViewWarehouseMovements'),
                allowAdding: false,
                allowDeleting: false,
                showConfirmDialog: false,
                showDeleteConfirmDialog: false,
                mode: 'Batch',
                newRowPosition: 'Top',
            };
        },

        showDwOnly() {
            this.showDWOnly = !this.showDWOnly;
            this.getMovements();
        },
        showPzOnly() {
            this.showPZOnly = !this.showPZOnly;
            this.getMovements();
        },
        getToolbar() {
            const tools = [];
		
           tools.push(
                "Update",
                "Cancel",
                { text: "Resetuj filtry", prefixIcon: 'e-reset', id: 'reset_filters' },
                { template: '<input id="customSearchInput" class="e-input" placeholder="Szukaj..." />', align: 'center' },
                { text: "Zapisz ustawienia", prefixIcon: 'e-save', id: "save", align: 'right' });
			if (this.hasTableSettings) {
                tools.push({ text: "Usuń ustawienia", prefixIcon: 'e-delete', id: "delete-set", align: 'right' });
            }
            tools.push({ text: "Przywróć domyślny", prefixIcon: 'e-undo', id: "restore", align: 'right' },
                { text: "Export do Excela", prefixIcon: 'e-excelexport', id: "excelexport", align: 'right' },
                "ColumnChooser");
			return tools;
        },

        clickToolbarHandler: async function (args) {

            if (args.item.id === 'add_btn') {
                this.showAddDocumentModal = true;
                this.$nextTick(() => {
                    this.$refs.addDocumentModalRef.show();
                });
            }



            if (args.item.id === 'warehouseMovementsGridId_update') {
                const grid = this.$refs.warehouseMovementsGrid.ej2Instances;
                grid.query = new Query().addParams('wholeMovement', true);

                // Sprawdź czy w zmienionych rekordach ktoś ustawił zamknięty = 1
                const changedRecords = grid.getBatchChanges()?.changedRecords ?? [];
                const closingRow = changedRecords.find(rec => rec.closed === 1);

                if (closingRow) {
                    args.cancel = true;

                    const result = await Toast.fire({
                        toast: false,
                        position: 'center',
                        icon: 'question',
                        title: 'Zamknięcie ruchu magazynowego',
                        html: 'Czy na pewno chcesz zamknąć wybrany ruch? Wszystkie pozycje w nim zostaną również zamknięte.',
                        showClass: { popup: 'animate__animated animate__fadeInDown' },
                        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
                        timer: false,
                        showConfirmButton: true,
                        confirmButtonText: 'Tak, zamknij',
                        showCancelButton: true,
                        cancelButtonText: 'Nie'
                    });

                    if (result.isConfirmed) {
                        grid.query = new Query().addParams('changed', changedRecords);
                        grid.endEdit(); // Dopiero TERAZ zapisujemy
                    }
                    // Inaczej robimy nic -> użytkownik może poprawić


                } else {
                    grid.endEdit(); // Nie ma zamknięcia? Normalny zapis
                }
            }


            /**
             * Akcja przy kliknięciu resetowania filtrów
             */
            if (args.item.id === 'reset_filters') {
                this.$refs.warehouseMovementsGrid.clearFiltering();
            }
            if (args.item.id === 'save') {
                const grid = this.$refs.warehouseMovementsGrid?.ej2Instances;

                if (!grid) {
                    console.warn('Grid nie został znaleziony');
                    this.errorMsg("Konfiguracja tabeli nie została zapisana!");
                    return;
                }
                const tableId = 'warehouseMovementsGrid';
                const settings = grid.columns.map((column, index) => ({
                    field: column.field || null,
                    index: index,
                    width: column.width,
                    visible: column.visible !== false
                }));
                try {
                    const response = await axios.post('/table-settings', {
                        tableId: tableId,
                        columns: JSON.stringify(settings)
                    });
                    this.hasTableSettings = true;
                    grid.toolbar = this.getToolbar();
                    this.successMsg("Konfiguracja tabeli została pomyślnie zapisana!");
                } catch (error) {
                    this.errorMsg("Konfiguracja tabeli nie została zapisana!");
                }
            }
            if (args.item.id === 'delete-set') {
                const tableId = 'warehouseMovementsGrid';
                try {
                    const response = await axios.delete('/table-settings-delete', {
                        data: {
                            tableId: tableId
                        }
                    }
                    );
                    this.hasTableSettings = false;
                    const grid = this.$refs.warehouseMovementsGrid?.ej2Instances;

                    if (grid) {
                        grid.toolbar = this.getToolbar();
                    }
                    this.successMsg(
                        "Konfiguracja tabeli została pomyślnie usunięta!"
                    );
                } catch (error) {
                    this.errorMsg(
                        "Konfiguracja tabeli nie została usunięta!"
                    );
                }
            }
            if (args.item.id === 'restore') {
                let grid = this.$refs.warehouseMovementsGrid;
                let gridName = 'grid' + grid.$el.id;
                grid.ej2Instances.enablePersistence = false;
                window.localStorage.setItem(gridName, "");
                grid.ej2Instances.destroy();
                this.applyTableSettings();
                location.reload();
            }

            if (args.item.id === 'excelexport') {
                this.$refs.warehouseMovementsGrid.excelExport({
                    fileName: `Stany magazynowe.xlsx`
                });
            }
        },

        onRowSelected(args) {
            this.selectedDocument = args.data ?? null;
            this.showViewMovementDetails = true;
            this.$nextTick(() => {
                if (this.$refs.viewMovementDetailsRef && this.selectedDocument) {
                    this.$refs.viewMovementDetailsRef.getMovements(this.selectedDocument);
                }
            });
        },


        getMovements() {
            this.warehouseMovementsDataManager = new DataManager({
                url: route('warehouse-movements.getGroupedList', {
                    showDWOnly: this.showDWOnly,
                    showPZOnly: this.showPZOnly
                }),
                adaptor: new WebMethodAdaptor(),
                batchUrl: route('warehouse-movements.saveChanges'),
                crossDomain: true,
                headers: [
                    { 'X-CSRF-TOKEN': usePage().props.csrf_token }
                ],
            });
        },

        updateGrid() {
            this.$refs.warehouseMovementsGrid.refresh();
        },

        dateFormatter(field, data) {
            const date = data.created_at ? data.created_at : null;
            if (date) {
                try {
                    return moment(date).format('DD.MM.YYYY HH:mm:ss');
                } catch (error) {
                    return data
                }
            }

            return '';
        },

        rowDataBound(args) {
            if (!this.tableSettingsApplied) {
                this.tableSettingsApplied = true;
                this.applyTableSettings();
            }
            if (!args || !args.data || args.data.isSummaryRow || args.data.isGroup) return;

            if (args.data.closed === 1) {
                args.row.style.backgroundColor = '#f5f5f5';
                args.row.style.opacity = 0.4;
            }
        },

        showDocument(movement) {
            this.selectedMovement = movement;
            const isDW = movement.document_number?.startsWith('DW');

            this.selectedItem = {
                ...movement,
                team_name: isDW ? movement.team_name : null,
                project_short: isDW ? movement.project_short_name : null,
            };

            this.isFilled = true;

            if (!movement.closed && (!movement.signed_date
                || !movement.who_receiving
                || !movement.who_issuing
                || !movement.purpose
            )) {
                this.isFilled = false;
            }
            this.showPreviewMovementPdfModal = true;
            this.$nextTick(() => {
                this.$refs.previewMovementPdfModalRef.show();
            });
        },

        successMsg(resp) {
            Toast.fire({
                position: 'top-end',
                toast: true,
                icon: 'success',
                title: 'Sukces!',
                html: resp,
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' },
                timer: 2500,
                timerProgressBar: true,
                showConfirmButton: false,
                showCloseButton: true
            });
        },

        errorMsg(resp) {
            Toast.fire({
                position: 'top-end',
                toast: true,
                icon: 'warning',
                title: 'Błąd!',
                html: resp,
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' },
                timer: 2500,
                timerProgressBar: true,
                showConfirmButton: false,
                showCloseButton: true
            });
        },

        isAdmin() {
            return hasRole('ADMIN');
        },

        cellEdit(args) {
            // jeśli pozycja jest zamknięta i user nie jest adminem, nie pozwól na edycję
            if (args.rowData.closed === 1 && !this.isAdmin()) {
                args.cancel = true; // anuluje edycję tej komórki
                Toast.fire({
                    icon: 'info',
                    title: 'Nie można edytować zamkniętego ruchu magazynowego. W celu edycji, zgłoś się do administratora.'
                });
            }
        },

        actionComplete(args) {
            if (args.requestType === "batchsave") {  // Tylko dla operacji batchSave (zapis)
                if (args.changes && args.changes.changedRecords) {
                    // Sprawdzamy, czy `args.batchChanges` istnieje i czy są zmienione rekordy
                    this.successMsg('Dane magazynowe zostały zapisane.');

                } else if (args.error) {
                    // Jeśli wystąpił błąd, wywołaj `errorMsg` z wiadomością błędu
                    this.errorMsg("Wystąpił błąd podczas zapisu danych: " + args.error);
                }
            }
        },

        actionFailure(args) {
            const response = args?.error?.[0]?.error;
            if (!response) {
                this.errorMsg("Nieznany błąd.");
                return;
            }

            response.text()
                .then((text) => {
                    try {
                        const json = JSON.parse(text);
                        if (json.errors && Array.isArray(json.errors)) {
                            this.$emit("errorMsg", json.errors[0]);
                        } else {
                            this.$emit("errorMsg", json.message || text);
                        }
                    } catch (e) {
                        this.$emit("errorMsg", text);
                    }
                })
                .catch(() => {
                    this.$emit("errorMsg", "Nie udało się odczytać błędu z serwera.");
                });
        },

    }
}
</script>

<style scoped>
.not-editable {
    color: orangered;
}

.cursor-pointer {
    cursor: pointer;
}

.switches-bar {
    padding-top: 6px;
    /* delikatne „podniesienie” wizualne */
}

.switch-item {
    margin: 0 !important;
    /* usuwa bootstrapowe przesunięcia */
    line-height: 1;
    /* stabilizuje wysokość */
}

.switch-label {
    margin-bottom: 0;
    /* usuwa bootstrapowe „opadanie” tekstu */
    line-height: 1;
}

/* opcjonalnie: wyrównanie switcha do góry w razie różnych wysokości fontów */
.switch-item .form-check-input {
    margin-top: 0;
}
</style>